export class NoSessionError extends Error {
    
}